import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import HomePage from '../pages/HomePage/HomePage';
import Gene20Presents from '../pages/presentation/presentationII';
// import PortfolioPresentation from "../pages/presentation/portfolioPresentation/portfolioPresentation";
import PageRoutesData from './data/pageRoutesData';

const PageRoutes = (props) => {
  // const renderRoutes = routes.map(
  //   ({ type, name, icon, title, noCollapse, key, href, route }) => {
  //     let returnValue;

  //     if () {
  //       returnValue = href ? (
  //         <Link
  //           href={href}
  //           key={key}
  //           target="_blank"
  //           rel="noreferrer"
  //           sx={{ textDecoration: "none" }}
  //         >
  //           <sideNavCollapse
  //             name={name}
  //             icon={icon}
  //             active={key === collapseName}
  //             noCollapse={noCollapse}
  //           />
  //         </Link>
  //       ) : (
  //         <NavLink key={key} to={route}>
  //           <sideNavCollapse
  //             name={name}
  //             icon={icon}
  //             active={key === collapseName}
  //           />
  //         </NavLink>
  //       );
  //     } else if (type === "title") {
  //       returnValue = (
  //         <Typography
  //           key={key}
  //           color={textColor}
  //           display="block"
  //           variant="caption"
  //           fontWeight="bold"
  //           textTransform="uppercase"
  //           pl={3}
  //           mt={2}
  //           mb={1}
  //           ml={1}
  //         >
  //           {title}
  //         </Typography>
  //       );
  //     } else if (type === "divider") {
  //       returnValue = (
  //         <Divider
  //           key={key}
  //           light={
  //             (!darkMode && !whitesideNav && !transparentsideNav) ||
  //             (darkMode && !transparentsideNav && whitesideNav)
  //           }
  //         />
  //       );
  //     }

  //     return returnValue;
  //   }
  // );

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  return (
    <Routes>
      {getRoutes(PageRoutesData)}
      <Route path="/home" element={<Gene20Presents />} />
      <Route path="/" element={<Navigate to="/home" />} />
    </Routes>
  );
};

export default PageRoutes;
